import {statusStyles} from "@insite/content-library/Widgets/OrderDetails/OrderDetailsStatus";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import { css } from "styled-components";

statusStyles.titleText = {
    variant: "h3",
    css: css`
        @media print {
            font-size: 12px;
        }
        margin-bottom: 5px;
        font-size: 15px !important;
    `,
    transform: "uppercase",
    size: 15,
}

statusStyles.status = {
    size: 16,
}

statusStyles.wrapper = {
    css: css`
    padding-bottom: 0;
    ${({ theme }: { theme: BaseTheme }) =>
    breakpointMediaQueries(theme, [
        css`
            display: flex;
            justify-content: space-between;
            padding-right: 20%;
            padding-bottom: 10px;
        `,
        css`
            display: flex;
            justify-content: space-between;
            padding-right: 20%;
            padding-bottom: 10px;
        `,
        css`
            display: flex;
            justify-content: space-between;
            padding-right: 20%;
            padding-bottom: 10px;
        `,
        css`
        `,
        css`
        `,
    ])}
    `,
}